import useFeature from '../../SystemSettings/hooks/featureFlags/useFeature';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import { getAllowedTokensOptions } from '../PoliciesUtils';

export const useAllowedTokens = (
    currentSelectedTokens,
    configuredTokens,
    desktopEnabled,
    pingFedEnabled,
    modeType,
    radiusEnabled
) => {
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const isSaas = systemMode !== SYSTEM_MODES.ON_PREM;

    const allowedTokens = getAllowedTokensOptions(
        currentSelectedTokens ?? [],
        configuredTokens,
        desktopEnabled,
        pingFedEnabled,
        modeType,
        radiusEnabled,
        isSaas
    );

    return allowedTokens;
};
